import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';

import { inboxEntriesKeys } from '../components/Sidebar/api/getInboxEntries';

const url = `${PREFIX_URL}/userActivity`;

type LogActivityResponse = {
  activities: any;
};

export type LogActivityDTO = {
  data: any;
  type: string;
};

export const logCopyUrlActivity = (params: LogActivityDTO): Promise<LogActivityResponse> => {
  return axios.post(url, {
    ...params,
  });
};

type UselogActivityOptions = {
  config?: MutationConfig<typeof logCopyUrlActivity>;
};

export const useLogActivity = ({ config }: UselogActivityOptions = {}) => {
  return useMutation({
    onSuccess: (data) => {
      // @TODO: use immer to simplify?
      // queryClient.setQueriesData([...inboxEntriesKeys.lists({ projectId })], (prev: any) => {
      //   return {
      //     ...prev,
      //     pages: prev.pages.map((page) => {
      //       return {
      //         ...page,
      //         data: {
      //           ...page.data,
      //           entries: page.data.map((inboxEntry) => {
      //             if (inboxEntry.file?.id === fileId) {
      //               return {
      //                 ...inboxEntry,
      //                 isMisc: !inboxEntry.isMisc,
      //               };
      //             }
      //             return inboxEntry;
      //           }),
      //         },
      //       };
      //     }),
      //   };
      // });
    },
    ...config,
    mutationFn: logCopyUrlActivity,
  });
};
